export default {
    poweredBy: "Aangedreven door"
}